module.exports = __webpack_public_path__ + "static/media/lock.b2fc9216.png";